"use strict";

exports.__esModule = true;
exports.DomainName = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _whenModern = require("../Theme/UiDesign/whenModern");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DomainNameTitle = _styledComponents["default"].div.attrs({
  className: "domain-name"
}).withConfig({
  displayName: "DomainName__DomainNameTitle",
  componentId: "sc-8agjta-0"
})(["font-size:20px;", " position:absolute;top:20px;left:25px;"], (0, _whenModern.whenModern)("font-weight: 700; letter-spacing: -0.01em;", "font-weight: 400;"));
var DomainName = exports.DomainName = function DomainName(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/_react["default"].createElement(DomainNameTitle, null, name);
};